import { render } from "./CreateBackupOffering.vue?vue&type=template&id=0dc06dbe&scoped=true"
import script from "./CreateBackupOffering.vue?vue&type=script&lang=js"
export * from "./CreateBackupOffering.vue?vue&type=script&lang=js"

import "./CreateBackupOffering.vue?vue&type=style&index=0&id=0dc06dbe&scoped=true&lang=less"

import exportComponent from "/build/cloudstack-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc06dbe"]])

export default __exports__